export default {
  baseApiUrl: 'https://api.iasitaxi.ro',
  wsUrl: 'wss://ws.iasitaxi.ro',
  wsApiUrl: 'https://ws.iasitaxi.ro',
  googleMapsApiKey: 'AIzaSyBt9XxAHxFg-6cVke7aItRF4NDATE_wynM',
  userAddressesUrl: 'https://user-addresses.iasitaxi.ro',
  mapCenter: { lat: 47.151726, lng: 27.587914 },
  addrApiUrl: 'https://addr.iasitaxi.ro',
  addrApiUrlNew: 'https://places-1.ogo.taxi'
}
